<template>
  <!-- 子菜单（用户中心）开始 -->
  <el-aside width="auto">
    <div class="colpase" @click="checklabel">
      <i style="margin:0 auto;align-self:center" :class="{zk:a,sq:b}"></i>
    </div>
    <el-menu ref="menus" :default-openeds="defaultOpeneds" :default-active="leftNavIndex" :style="{height: hie+'px'}" class="el-menu-vertical-demo" :collapse="isCollapse" @select="handleSelect">
      <!-- 供应链中心 -->
      <template v-if="topMenuId == 560">
        <el-submenu popper-class="submenu" v-for="item in menuList[leftMenuShowHide].children" :key="item.id" :index="item.path">
          <template slot="title">
            <div style="display:flex">
              <i class="menuicon">
                <img v-if="item.name == '商铺管理' && $route.path != item.path" src="@/assets/menus_icon/dpgl.png">
                <img v-if="item.name == '商铺管理' && $route.path == item.path" src="@/assets/menus_icon/dpgl_active.png">
                <img v-if="item.name == '商品管理' && $route.path != item.path" src="@/assets/menus_icon/spgl.png">
                <img v-if="item.name == '商品管理' && $route.path == item.path" src="@/assets/menus_icon/spgl_active.png">
                <img v-if="item.name == '订单管理' && $route.path != item.path" src="@/assets/menus_icon/ddgl.png">
                <img v-if="item.name == '订单管理' && $route.path == item.path" src="@/assets/menus_icon/ddgl_active.png">
                <img v-if="item.name == '售后管理' && $route.path != item.path" src="@/assets/menus_icon/shgl.png">
                <img v-if="item.name == '售后管理' && $route.path == item.path" src="@/assets/menus_icon/shgl_active.png">
                <img v-if="item.name == '客服管理' && $route.path != item.path" src="@/assets/menus_icon/kfgl.png">
                <img v-if="item.name == '客服管理' && $route.path == item.path" src="@/assets/menus_icon/kfgl_active.png">
                <img v-if="item.name == '运营管理' && $route.path != item.path" src="@/assets/menus_icon/yygl.png">
                <img v-if="item.name == '运营管理' && $route.path == item.path" src="@/assets/menus_icon/yygl_active.png">
                <img v-if="item.name == '用户管理' && $route.path != item.path" src="@/assets/menus_icon/user.png">
                <img v-if="item.name == '用户管理' && $route.path == item.path" src="@/assets/menus_icon/user_active.png">
                <img v-if="item.name == '材料定额库' && $route.path != item.path" src="@/assets/menus_icon/cldek.png">
                <img v-if="item.name == '材料定额库' && $route.path == item.path" src="@/assets/menus_icon/cldek_active.png">
                <img v-if="item.name == '结算管理' && $route.path != item.path" src="@/assets/menus_icon/jsgl.png">
                <img v-if="item.name == '结算管理' && $route.path == item.path" src="@/assets/menus_icon/jsgl_active.png">
                <img v-if="item.name == 'BOS客户管理' && $route.path != item.path" src="@/assets/menus_icon/bos_khgl.png">
                <img v-if="item.name == 'BOS客户管理' && $route.path == item.path" src="@/assets/menus_icon/bos_khgl_active.png">
                <img v-if="item.name == 'BOS样品库管理' && $route.path != item.path" src="@/assets/menus_icon/ypkgl.png">
                <img v-if="item.name == 'BOS样品库管理' && $route.path == item.path" src="@/assets/menus_icon/ypkgl_active.png">
                <img v-if="item.name == '发票管理' && $route.path != item.path" src="@/assets/menus_icon/invoice.png">
                <img v-if="item.name == '发票管理' && $route.path == item.path" src="@/assets/menus_icon/invoice_active.png">
              </i>
              <!-- :style="leftNavIndex == '/eMerchantManagement' || leftNavIndex == '/eMerchantReview' || leftNavIndex == '/eShopManagement' || leftNavIndex == '/eToBeReviewedShopInfo' || leftNavIndex == '/eInvestmentClueManagement' || leftNavIndex == '/eMerchantManagementt' ? 'color:#409EFF' : ''" -->
              <span :style="$route.path == item.path ? 'color:#409EFF' : ''">{{ item.name }}</span>
            </div>
          </template>
          <el-menu-item style="font-size: 12px;" v-for="childItem in item.children" :key="childItem.id" :index="childItem.path">{{ childItem.name }}</el-menu-item>
          <el-menu-item v-if="item.name == '结算管理'" style="font-size: 12px;" index="/eAlipayBillManage">支付宝账单管理</el-menu-item>
        </el-submenu>
      </template>
      <!-- 企业库 -->
      <template v-if="topMenuId == 561">
        <el-submenu popper-class="submenu" v-for="item in menuList[leftMenuShowHide].children" :key="item.id" :index="item.path">
          <template slot="title">
            <div style="display:flex">
              <i class="menuicon">
                <img v-if="item.name == '企业库进度' && $route.path != item.path" src="@/assets/menus_icon/qykjd.png">
                <img v-if="item.name == '企业库进度' && $route.path == item.path" src="@/assets/menus_icon/qykjd_active.png">
                <img v-if="item.name == '企业库踏勘' && $route.path != item.path" src="@/assets/menus_icon/qyktk.png">
                <img v-if="item.name == '企业库踏勘' && $route.path == item.path" src="@/assets/menus_icon/qyktk_active.png">
              </i>
              <span :style="$route.path == item.path ? 'color:#409EFF' : ''">{{ item.name }}</span>
            </div>
          </template>
          <el-menu-item style="font-size: 12px;" v-for="childItem in item.children" :key="childItem.id" :index="childItem.path">{{ childItem.name }}</el-menu-item>
        </el-submenu>  
      </template>
      <!-- 供应商 -->
      <template v-if="topMenuId == 562">
        <template v-for="item in menuList[leftMenuShowHide].children">
          <!-- 有子级 -->
          <el-submenu popper-class="submenu" :key="item.id" :index="item.path" v-if="item.children">
            <template slot="title">
              <div style="display:flex">
                <i class="menuicon">
                  <img v-if="item.name == '供应商管理' && $route.path != item.path" src="@/assets/menus_icon/gysgl.png">
                  <img v-if="item.name == '供应商管理' && $route.path == item.path" src="@/assets/menus_icon/gysgl_active.png">
                  <img v-if="item.name == '供应商保证金' && $route.path != item.path" src="@/assets/menus_icon/gysbzj.png">
                  <img v-if="item.name == '供应商保证金' && $route.path == item.path" src="@/assets/menus_icon/gysbzj_active.png">
                  <img v-if="item.name == '供应商积分' && $route.path != item.path" src="@/assets/menus_icon/gysjf.png">
                  <img v-if="item.name == '供应商积分' && $route.path == item.path" src="@/assets/menus_icon/gysjf_active.png">
                </i>
                <span :style="$route.path == item.path ? 'color:#409EFF' : ''">{{ item.name }}</span>
              </div>
            </template>
            <el-menu-item style="font-size: 12px;" v-for="childItem in item.children" :key="childItem.id" :index="childItem.path">{{ childItem.name }}</el-menu-item>
          </el-submenu>  
          <!-- 没有子级 -->
          <el-menu-item v-else :key="item.id" :index="item.path">
            <img v-if="item.name == '供应商考核' && $route.path != item.path" style="padding-left:5px" src="@/assets/menus_icon/gyskh.png">
            <img v-if="item.name == '供应商考核' && $route.path == item.path" style="padding-left:5px" src="@/assets/menus_icon/gyskh_active.png">
            <span style="padding-left:7px">{{ item.name }}</span>
            </el-menu-item>
        </template>
      </template>
      <!-- SaaS中心 -->
      <template v-if="topMenuId == 563">
        <template v-for="item in menuList[leftMenuShowHide].children">
          <el-submenu popper-class="submenu" :key="item.id" :index="item.path" v-if="item.children">
            <template slot="title">
              <div style="display:flex">
                <i class="menuicon">
                  <img v-if="item.name == '客户管理' && $route.path != item.path" src="@/assets/menus_icon/khgl.png">
                  <img v-if="item.name == '客户管理' && $route.path == item.path" src="@/assets/menus_icon/khgl_active.png">
                </i>
                <span :style="$route.path == item.path ? 'color:#409EFF' : ''">{{ item.name }}</span>
              </div>
            </template>
            <el-menu-item style="font-size: 12px;" v-for="childItem in item.children" :key="childItem.id" :index="childItem.path">{{ childItem.name }}</el-menu-item>
          </el-submenu>  
          <el-menu-item v-else :key="item.id" :index="item.path">
            <img v-if="item.name == '企业管理' && $route.path != item.path" style="padding-left:5px" src="@/assets/menus_icon/qygl.png">
            <img v-if="item.name == '企业管理' && $route.path == item.path" style="padding-left:5px" src="@/assets/menus_icon/qygl_active.png">
            <span style="padding-left:7px">{{ item.name }}</span>
            </el-menu-item>
        </template>
      </template>
      <!-- 平台运营 -->
      <template v-if="topMenuId == 564">
        <template v-for="item in menuList[leftMenuShowHide].children">
          <el-menu-item v-if="!item.children" :key="item.id" :index="item.path">
            <img v-if="item.name == '内容管理' && isSjdp || $route.path != item.path && item.name == '内容管理'" style="padding-left:5px" src="@/assets/menus_icon/nrgl.png">
            <img v-if="item.name == '内容管理' && $route.path == item.path && !isSjdp" style="padding-left:5px" src="@/assets/menus_icon/nrgl_active.png">
            <img v-if="item.name == '题库管理' && isSjdp || $route.path != item.path && item.name == '题库管理'" style="padding-left:5px" src="@/assets/menus_icon/tkgl.png">
            <img v-if="item.name == '题库管理' && $route.path == item.path && !isSjdp" style="padding-left:5px" src="@/assets/menus_icon/tkgl_active.png">
            <img v-if="item.name == '门户新闻' && isSjdp || $route.path != item.path && item.name == '门户新闻'" style="padding-left:5px" src="@/assets/menus_icon/mhgl.png">
            <img v-if="item.name == '门户新闻' && $route.path == item.path && !isSjdp" style="padding-left:5px" src="@/assets/menus_icon/mhgl_active.png">
            <img v-if="item.name == '举报中心' && isSjdp || $route.path != item.path && item.name == '举报中心'" style="padding-left:5px" src="@/assets/menus_icon/jbzx.png">
            <img v-if="item.name == '举报中心' && $route.path == item.path && !isSjdp" style="padding-left:5px" src="@/assets/menus_icon/jbzx_active.png">
            <img v-if="item.name == '数据大屏' && !isSjdp" style="padding-left:5px" src="@/assets/menus_icon/sjdp.png">
            <img v-if="item.name == '数据大屏' && $route.path != item.path && isSjdp" style="padding-left:5px" src="@/assets/menus_icon/sjdp_active.png">
            <img v-if="item.name == 'e装驾驶舱' && !isSjdp" style="padding-left:5px" src="@/assets/menus_icon/ezjsc.png">
            <img v-if="item.name == 'e装驾驶舱' && $route.path != item.path && isSjdp" style="padding-left:5px" src="@/assets/menus_icon/ezjsc_active.png">
            <img v-if="item.name == 'e购驾驶舱' && !isSjdp" style="padding-left:5px" src="@/assets/menus_icon/egjsc.png">
            <img v-if="item.name == 'e购驾驶舱' && $route.path != item.path && isSjdp" style="padding-left:5px" src="@/assets/menus_icon/egjsc_active.png">
            <span style="padding-left:7px">{{ item.name }}</span>
            </el-menu-item>
        </template>
      </template>
      <!-- 系统管理 -->
      <template v-if="topMenuId == 565">
        <template v-for="item in menuList[leftMenuShowHide].children">
          <el-submenu popper-class="submenu" :key="item.id" :index="item.path" v-if="item.children">
            <template slot="title">
              <div style="display:flex">
                <i class="menuicon">
                  <img v-if="item.name == '升级管理' && $route.path != item.path" src="@/assets/menus_icon/sjgl.png">
                  <img v-if="item.name == '升级管理' && $route.path == item.path" src="@/assets/menus_icon/sjgl_active.png">
                  <img v-if="item.name == '企业账户管理' && $route.path != item.path" src="@/assets/menus_icon/qyzhgl.png">
                  <img v-if="item.name == '企业账户管理' && $route.path == item.path" src="@/assets/menus_icon/qyzhgl_active.png">
                  <img v-if="item.name == '权限人员管理' && $route.path != item.path" src="@/assets/menus_icon/qxrygl.png">
                  <img v-if="item.name == '权限人员管理' && $route.path == item.path" src="@/assets/menus_icon/qxrygl_active.png">
                </i>
                <span :style="$route.path == item.path ? 'color:#409EFF' : ''">{{ item.name }}</span>
              </div>
            </template>
            <el-menu-item style="font-size: 12px;" v-for="childItem in item.children" :key="childItem.id" :index="childItem.path">{{ childItem.name }}</el-menu-item>
          </el-submenu>  
        </template>
      </template>
    </el-menu>
  </el-aside>
  <!-- 子菜单（用户中心）结束 -->
</template>

<script>
import { setStorage,getStorage } from '@/service/auth.js';
  export default {
    data() {
      return {
        isCollapse: false,
        a: false,
        b: true,
        hie: window.innerHeight - 98,
        topNavIndex: window.sessionStorage['topNavIndex'] || this.$route.path,
        leftNavIndex: getStorage('commodityType') != undefined ? '/eMerchantManagement' : window.sessionStorage['leftNavIndex'] || '/Administration',
        NavIndex: window.sessionStorage['leftNavIndex'] || this.$route.path,
        menuList:this.$store.state.menuList,
        routerListNew:this.$store.state.routerListNew,
        isSjdp: false,
        leftMenuShowHide: window.sessionStorage['leftMenuShowHide'],
        topMenuId: window.sessionStorage['topMenuId'],
        defaultOpeneds: [], 
      };
    },
    watch: {
      '$route.path': {
        handler(newValue, oldValue) {
          let changeFlag = false;
          for (let i=0; i<this.menuList.length; i++){
            if(this.menuList[i].children[0].path == newValue){
              changeFlag = true;
              break;
            }
          };
          if(changeFlag) {
            this.leftNavIndex = newValue;
            window.sessionStorage['leftNavIndex'] = newValue;
          };
        },
        deep: true,
        immediate: true
      }
    },
    created() {
      // let routes = this.$router.options.routes;
      // this.defaultOpeneds = routes.map(item => item.path);
      
      // 修复点击二级菜单后，一级菜单收起打开的问题
      let arr = [];
      this.menuList.map(item => {
        if(item.children) {
          item.children.map(childItem => {
            if(childItem.children) {
              if(childItem.path == this.$route.path) {
                childItem.children.map(childItems => {
                  arr.push(childItems.path);
                })
              }
            }
          })
        }
      })
      this.defaultOpeneds = arr;
    },
    methods: {
      handleSelect(key, keyPath) {
        window.localStorage.removeItem('sample_id')
        window.localStorage.removeItem('use_bid')
        window.localStorage.removeItem('call_bid_id')
        window.localStorage.removeItem('commodityType')
        window.localStorage.removeItem('spu_id')
        window.localStorage.removeItem('use_merchant_name')
        this.leftNavIndex = key;
        window.sessionStorage['leftNavIndex'] = key;
        window.sessionStorage['topNavIndex'] = key;
        if (key == '/presentation') {
          this.isSjdp = true;
          window.open('/#/presentation', '_blank');
        } else if (key == '/eFitUp') {
          this.isSjdp = false;
          window.open('/#/eFitUp', '_blank');
        } else if (key == '/eBuy') {
          this.isSjdp = false;
          window.open('/#/eBuy', '_blank');
        } else {
          this.isSjdp = false;
          this.$router.push(key);
        }
        this.$store.commit('SET_MENU_LIST', key);
      },
      openPresentation() {
        if (getStorage('state') == 'def66765f94b310fdd01fe6f0fc8239f') { // 判断是否是biboard
          window.open('/#/biBoard', '_blank');
        } else {
          window.open('/#/presentation', '_blank');
        }
      },
      checklabel() {
        if (this.isCollapse) {
          this.isCollapse = false
          this.b = true;
          this.a = false;
        } else {
          this.isCollapse = true;
          this.a = true;
          this.b = false;
        }
      },
    },
  }
</script>

<style lang="scss" scoped>
.el-aside {
  .menuicon {
    display: inline-block;
    margin: 0 5px;
    vertical-align: middle;
    img {
      margin-right: 5px;
    }
  }
}
.el-menu-item {
  a {
    width: 100%;
    height: 100%;
    display: block;
  }
}
.el-submenu.is-active,.el-menu-item.is-active {
  background: #eff6fd !important;
  color: #409EFF !important;
  .el-submenu__title {
    color: #409EFF!important;
    background: #eff6fd !important;
  }
  a {
    color: #409EFF!important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/corenav.vue